import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConfigService } from 'app/shared/config.service';
import { Observable } from 'rxjs';
import { Tickets } from '../Shared/model/tickets';
import { EProvider } from '../Shared/enum/provider.enum';
import { Order } from '../Shared/model/order';
import { ResultOfOperation } from '../../Shared/model/result-of-operation.model';
import { AvailableTickets } from '../Shared/model/available-tickets';
import { EVoucherType } from '../Shared/enum/voucher-type.enum';
import { VoucherArkia } from "../Models/VoucherArkia";
import { VouchersModule } from "../vouchers/vouchers.module";

@Injectable({
    providedIn: 'root',
  })
export class OrderService
{
    private apiUrl: string = "";
    constructor(
        private _httpClient:HttpClient,
        private _configService:ConfigService) 
        { 
        this.apiUrl = this._configService.getConfigPropertyByKey("apiUrl");
        console.log('vouchers service config',this.apiUrl)
        }

    getTicketPrices(provider:number):Observable<ResultOfOperation<Tickets[]>>
    {
        
            let url = `${this.apiUrl}/api/vouchers/GetTicketsPrices`;
            const headers = new HttpHeaders().set('Content-type','application/json');
            const options = { 
               headers: headers,
               params: new HttpParams().set('provider', provider.toString())
           };
            return this._httpClient.get<ResultOfOperation<Tickets[]>>(url,options); 
    }
    CreateNewOrderArkiaAndGetVouchers(order:Order) : Observable<ResultOfOperation<VoucherArkia[]>>
    {
        let url = `${this.apiUrl}/api/vouchers/CreateNewOrderArkiaAndGetVouchers`;
        const headers = new HttpHeaders().set('Content-Type','application/json');
       return  this._httpClient.post<ResultOfOperation<VoucherArkia[]>>(url,order);
    }

    getTotalTicketsAvailable(providerId : EProvider, voucherType : EVoucherType) : Observable<ResultOfOperation<AvailableTickets>>
    {
        let url = `${this.apiUrl}/api/vouchers/GetAllTicketsAvailable`;
        const headers = new HttpHeaders().set("Content-Type","application/json");
        const options = {
            headers : headers,
            params : new HttpParams().set("providerId", providerId.toString()).set("voucherType" , voucherType.toString())
        }
        return this._httpClient.get<ResultOfOperation<AvailableTickets>>(url,options);

    }
    GetUserUsedBenefitsAmount() : Observable<ResultOfOperation<number>>
    {
        let url = `${this.apiUrl}/api/voucher/GetUserBenefitsAmount`;
        const headers = new HttpHeaders().set("Content-Type","application/json");
        const options = {
            headers : headers
        }
        return this._httpClient.get<ResultOfOperation<number>>(url,options);
    }
}